"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.json2View = json2View;
Object.defineProperty(exports, "addTransChain", {
  enumerable: true,
  get: function get() {
    return _ele2Node.addTransChain;
  }
});
Object.defineProperty(exports, "ele2VNode", {
  enumerable: true,
  get: function get() {
    return _ele2Node.ele2VNode;
  }
});

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _ele2Node = require("./ele2Node");

function transElements(ele, data) {
  if (!ele || (0, _typeof2.default)(ele) !== 'object' || Array.isArray(ele)) {
    return ele;
  }

  if (ele.type === 'transElements') {
    return (0, _ele2Node.ele2VNode)(ele.elements, data);
  }

  var out = {};
  Object.keys(ele).forEach(function (key) {
    out[key] = transElements(ele[key], data);
  });
  return out;
}

(0, _ele2Node.addTransChain)(transElements);

function json2View(h, json) {
  return (0, _ele2Node.ele2VNode)(h, JSON.parse(json));
}